import fetch from 'unfetch';

function calculateEndpoint(hostname = window.location.hostname) {
  let endpoint = 'https://app.clearbit.com';

  const localDevelopment = 'localhost' === hostname;
  const webLocal = 'web.local' === hostname;
  const xBranch = /^clearbit-x-pr-\d+\.dev\.clearbit\.com$/.test(hostname);
  if (localDevelopment || webLocal || xBranch) {
    return '';
  }

  const development = /dev\.clearbit\.com$/.test(hostname);
  if (development) {
    return 'https://clearbit-x.dev.clearbit.com';
  }

  const staging = /staging\.clearbit\.com$/.test(hostname);
  if (staging) {
    return 'https://app.staging.clearbit.com';
  }

  return endpoint;
}

const endpoint = calculateEndpoint();

function queryParams(params) {
  return Object.keys(params)
    .map(
      (key) => encodeURIComponent(key) + '=' + encodeURIComponent(params[key]),
    )
    .join('&');
}

function request(options) {
  let url = endpoint + options.path;

  return fetch(url, {
    method: options.type,
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(options.json),
  })
    .then((response) => {
      return response.text().then((body) => {
        // Handle responses that return an empty body ahead of time, since
        // response.json() will throw an error.
        if (body === '') {
          if (response.ok) {
            return Promise.resolve({ status: 'ok', body });
          } else {
            return Promise.reject({ response, status: response.status });
          }
        }

        return response;
      });
    })
    .then((response) => {
      if (response.body === '') {
        return Promise.resolve(response);
      }

      if (response.ok) {
        return response.json();
      } else {
        return response.json().then((json) => {
          json.response = response;
          json.status = response.status;
          return Promise.reject(json);
        });
      }
    })
    .then((json) => {
      if (json.error) {
        return Promise.reject(json);
      }

      return json;
    });
}

export default request;
export { calculateEndpoint, endpoint, queryParams };
